























































import _ from 'lodash'
import { Component, Prop } from 'vue-property-decorator'
import BaseInput from '@/services/BaseInput'

@Component
export default class InputText extends BaseInput {
  @Prop() public isLoading?: boolean
  @Prop() public appnedOuterText?: string
  @Prop() public prependOuterText?: string

  public onEmitEvent(ev) {
    this.$emit('event', ev, this.name)
  }

  public onBlur(ev) {
    this.$emit('blur', ev, this.name)
  }
}
